import * as React from "react";
function SvgMessage(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 18v-2H4V6h16v10h-9.273l-.572.52L8 18.48V18zm12 0h-8.5l-3.827 3.48C7.03 22.062 6 21.607 6 20.74V18H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2zM6 10h12V8H6v2zm0 4h8v-2H6v2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgMessage);
export default ForwardRef;
